import React from 'react';
import courses from '../config/courses'

export default function Selector() {

    const atualCourse = courses[0];
    
    return (
        <div className= 'mb-4 selector bg-edited-dark'>
            <h2 className='text-light m-4 video-text text-H2' >{atualCourse.title}</h2>
            {atualCourse.topics.map((topic, indexTopic) => {
                
                const target = `#collapseExample-${indexTopic}-${topic.id}`
                const id = `collapseExample-${indexTopic}-${topic.id}`
                
                return (
                    <ul className='list-group  mt-3 mb-3' key={topic.id}>
                        
                        <div className='align-middle p-2 topic'>
                        <h6 className='text-light video-text text-H6' type="button" data-toggle="collapse" data-target={target} aria-expanded="false" aria-controls={target} >{topic.title}</h6>
                        </div>

                        <div className='collapse' id={id}> 
                            {topic.lessons.map((lesson, indexLesson) => {
                                return (
                                    <li key={lesson.id} type="button" className='list-lesson m-0'><h6 className='text-light ml-3 pt-2 video-text-lesson text-H6'>{lesson.title}</h6></li>
                                )
                            })}
                        </div>
                    </ul>
                )
            })}
        </div>
    );
}
